import { DefaultTheme } from 'styled-components'
import { ButtonAppearanceEnum } from '../components/Button/types'

const ThemeStyle: DefaultTheme = {
  fontSizes: ['10px', '12px', '14px', '16px', '18px', '20px'],
  space: ['10px', '16px', '24px', '32px', '48px', '64px'],
  colors: {
    layout: 'linear-gradient(118.34deg, rgba(115, 144, 254, 0.2) 18.69%, rgba(115, 144, 254, 0) 56.36%), #F1F4FC',
    layout2: 'linear-gradient(359.19deg,rgb(18 34 62) -8.64%,rgb(5 11 32) 46.83%) rgb(15,14,26)',
    primary: 'rgb(0, 0, 0)',
    secondary: 'rgba(0, 0, 0, 0.7)',
    accent: 'rgb(5,147,236)',
    dark: 'rgb(0, 0, 0)',
    light: 'rgb(229, 229, 229)',
    footer: 'rgb(15, 14, 26)',
    catalog: 'rgb(15, 14, 26)',
    disabled: 'rgb(215,208,208)',
    error: "#ea3943",
    success: "#16c784"
  },
  button: {
    [ButtonAppearanceEnum.primary]: {
      color: 'rgb(255,255,255)',
      background: '#4FBC87',
      fontSize: '14px',
      activeBackground: '#48AF7D',
      border: "1px solid #D2DCFF",
      width: "126px",
      height: "36px",
    },
    [ButtonAppearanceEnum.secondary]: {
      color: '#4FBC87',
      background: '#fff',
      fontSize: '14px',
      padding: '0',
      activeBackground: '#f1efef',
      border: "none",
      width: "126px",
      height: "36px",
      fontWeight: 500
    },
    [ButtonAppearanceEnum.gradient]: {
      color: 'rgb(255, 255, 255)',
      background: "linear-gradient(130.22deg, #9199FF 26.49%, #3C95DB 100.77%)",
      fontSize: '14px',
      width: '220px',
      height: '44px',
      fontWeight: 500,
      border: "1px solid #D2DCFF",
      activeBackground: "linear-gradient(130.22deg, #9199FF 26.49%, #3C95DB 100.77%)",
    },
    [ButtonAppearanceEnum.grey]: {
      color: 'rgba(37,37,37,0.5)',
      background: '#F1F1F1',
      fontSize: '14px',
      activeBackground: '#e8e6e6',
      border: "none",
      width: "126px",
      height: "36px",
    },
    [ButtonAppearanceEnum.purple]: {
      color: '#fff',
      background: '#6482E6',
      fontSize: '14px',
      activeBackground: '#4969D8',
      border: "none",
      width: "126px",
      height: "36px",
    },
    [ButtonAppearanceEnum.mobile]: {
      color: '#252525',
      background: '#fff',
      fontSize: '14px',
      activeBackground: '#BCCAFF',
      activeColor: "#6482E6",
      border: "none",
      width: "345px",
      height: "60px",
    },
  },
  transition: 'ease 0.15s',
  borderRadius: '16px',
  textShadow: 'rgb(0 151 255) 0px 0px',
  opacity: '0.64',
}

export default ThemeStyle
